import { render, staticRenderFns } from "./language_selector.vue?vue&type=template&id=a385868e&"
import script from "./language_selector.vue?vue&type=script&lang=js&"
export * from "./language_selector.vue?vue&type=script&lang=js&"
import style0 from "./language_selector.vue?vue&type=style&index=0&id=a385868e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports